import { Injectable, Injector } from '@angular/core';
import { InjectableByKey } from '@common-modules/shared/injectable-by-key/injectable-by-key.decorator';
import { IAlarmHistoryDto } from '../../dependencies/alarms/alarm-history.dto';
import { PagedResultDto } from '../../shared/model/paged-result.dto';
import { GridODataService } from '../../shared/odata/grid-odata.service';

@InjectableByKey({ key: 'HistoricalAlarmsGridService' })
@Injectable({ providedIn: 'root' })
export class HistoricalAlarmsGridService extends GridODataService<IAlarmHistoryDto> {
  constructor(injector: Injector) {
    super(injector, '/api/alarm/historical');
  }

  protected mapResponse(
    response: PagedResultDto<IAlarmHistoryDto>
  ): PagedResultDto<IAlarmHistoryDto> {
    return response;
  }
}
